import { useEffect, useState } from "react";
import { MapContainer } from "react-leaflet";

/**
 * StrictModeSafeMap
 * ------------------
 * react-leaflet's MapContainer initialises Leaflet imperatively on the raw DOM
 * node. React 18 StrictMode double-invokes effects in dev which trips Leaflet's
 * "Map container is already initialized" error. Delaying the render by one
 * microtask via useEffect avoids the double-mount race entirely.
 */
export default function StrictModeSafeMap({ children, ...props }) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    setReady(true);
  }, []);
  if (!ready) return null;
  return <MapContainer {...props}>{children}</MapContainer>;
}
